<template>
    <div class="amazonKey-main-container">
        <LeftMenu @updateTab="selectedTab = $event" />
        <div
            v-show="verifications && !loading"
            class="amazonKey-content-wrapper"
        >
            <div class="title-wrapper">
                <ClassicBreadCrumb :title="$t('amazonKey.title')" />
                <h1>{{ $t("amazonKey.title") }}</h1>
                <p v-if="selectedTab === 'details'">
                    *{{ $t("vigik.form.obligatoryFields") }}
                </p>
            </div>
            <div
                class="content-wrapper"
                :style="{
                    overflow: selectedTab === 'details' ? 'auto' : 'hidden',
                }"
            >
                <CreateOrEdit
                    v-show="selectedTab === 'details'"
                    @update:canBeSaved="updateCanBeSaved"
                    @loading="updateLoading"
                />
                <Events
                    v-if="selectedTab === 'events'"
                    @loading="updateLoading"
                />
            </div>
        </div>
        <div v-show="!verifications || loading" class="loader">
            <Loader />
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification"

import CreateOrEdit from "@/views/amazonKey/CreateOrEdit.vue"
import Events from "@/views/amazonKey/Events.vue"
import LeftMenu from "@/views/amazonKey/LeftMenu.vue"
import ClassicBreadCrumb from "@/components/entities/ClassicBreadCrumb.vue"
import Loader from "@/components/basic/Loader.vue"

const toast = useToast()

export default {
    components: {
        CreateOrEdit,
        Events,
        LeftMenu,
        ClassicBreadCrumb,
        Loader,
    },

    data() {
        return {
            verifications: false,
            loading: false,
            selectedTab: "details",
            displayAdvertiseModale: false,
        }
    },

    computed: {
        breadcrumb() {
            return this.$store.getters["breadCrumb/getClassicBreadCrumb"]
        },
    },

    methods: {
        updateLoading(value) {
            this.loading = value
        },

        updateCanBeSaved(value) {
            this.displayAdvertiseModale = value
        },
    },

    created() {
        if (!this.$route.params.accessId) {
            toast.warning(this.$t("alerts.navigations.notAccessible"))
            this.$router.go(-1)
        } else {
            this.verifications = true
        }
    },

    async beforeRouteLeave(to, from) {
        if (!this.displayAdvertiseModale) return true

        return await new Promise((resolve) => {
            this.openModal("validation", {
                title: "warning",
                question: this.$t("amazonKey.details.form.notSaved"),
                valid: () => resolve(true),
                refuse: () => {
                    this.$router.go(1)
                    resolve(false)
                },
            })
        })
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

h1,
p {
    margin: 0;
}

.amazonKey-main-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: flex;

    .amazonKey-content-wrapper {
        max-width: 100%;
        width: 100%;
        padding: 20px 4em;
        overflow: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 2em;

        .title-wrapper {
            display: flex;
            flex-direction: column;
            gap: 1em;

            h1 {
                font-family: $font_avenir_black;
            }

            p {
                font-size: $semiNormal;
            }
        }

        @media all and (max-width: 1024px) {
            padding: 20px 20px 10px 20px;
        }

        .content-wrapper {
            height: 100%;
            flex-grow: 1;
        }
    }
}

.loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
